module.exports = __webpack_public_path__ + "previous.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/previous.svg?color1=%23333333&color2=
// module id = 917
// module chunks = 67